import React from "react";
import { useDispatch } from "react-redux";
import { bool } from "prop-types";

import NumberInput from "@components/shared/NumberInput";

import { i18n, useTranslation } from "@lib/i18n";
import { dealType } from "@types";
import { getSolJourneyConfigForJourney } from "@shared/v2/lib/getSolJourneyConfigForJourney";
import { useAppConfigSelector } from "@redux/reducers/appConfig";
import { setVehicleQuantityAction } from "@redux/actions/dealActions";
import api from "@api";
import { getRequestCanceller } from "@shared/v2/lib/getRequestCanceller";
import { useDebounce } from "@hooks/useDebounce";
import { toast } from "@lib/reactToastify";

const journeySessionUpdateRequestCanceller = getRequestCanceller();

const VehicleQuantityInput = ({ deal, isEditable }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const appConfig = useAppConfigSelector();
  const debounce = useDebounce();

  const {
    businessModel,
    financeSimulation: { journey },
    currentDeal,
    quantity,
  } = deal;

  const configuration = currentDeal?.configuration ?? appConfig.configuration;

  const { multipleVehicles: quantitySettings } = getSolJourneyConfigForJourney(
    journey,
    businessModel,
    configuration
  );

  const handleChange = quantity => {
    dispatch(setVehicleQuantityAction(quantity));

    debounce(() => {
      journeySessionUpdateRequestCanceller(cancelSource =>
        api.updateSession({ quantity }, { cancelToken: cancelSource.token })
      ).catch(error => {
        toast.error(
          i18n.t("notify.failedToUpdateQuantity"),
          {
            toastId: "failed-to-update-quantity-in-session",
          },
          error
        );
      });
    }, 250);
  };

  return (
    <div className="flex flex-wrap justify-between items-center py-4">
      <label className="py-2 uppercase font-semibold">
        {t("VehicleQuantityInput.label")}
      </label>
      <NumberInput
        disabled={!isEditable}
        value={quantity}
        onChange={handleChange}
        minimum={quantitySettings?.minimum}
        minimumErrorMessage={t("VehicleQuantityInput.rangeError", {
          minimum: quantitySettings?.minimum,
          maximum: quantitySettings?.maximum,
        })}
        maximum={quantitySettings?.maximum}
        maximumErrorMessage={t("VehicleQuantityInput.rangeError", {
          minimum: quantitySettings?.minimum,
          maximum: quantitySettings?.maximum,
        })}
      />
    </div>
  );
};

VehicleQuantityInput.propTypes = {
  deal: dealType.isRequired,
  isEditable: bool,
};

export default VehicleQuantityInput;
